import axios from "axios";
import { useQuery } from "react-query";
import { ConfigParameters } from "types/types";

export function useConfigParameters() {
  const fetch = async () => {
    const { data } = await axios.get<ConfigParameters>(
      `/api/configparameters`
    );
    return data;
  };
  return useQuery(["configparameters"], fetch, {
    cacheTime: Infinity,
    staleTime: Infinity,
  });
}
